<template>
    <div class="demo-nav">
        <div class="">
            <div>
                这是抗疫信息这是抗疫信息这是抗疫信息这是抗疫信息这是抗疫信息这是抗疫信息这是抗疫信息这是抗疫信息这是抗疫信息这是抗疫信息
            </div>
            <div>
                <div>已申领</div>
                <div style="text-align: center">
                    <van-button icon="plus" to="/register" type="primary">口罩申领</van-button>
                </div>
            </div>
        </div>
        <div class="">
<!--            <van-tabbar v-model="active">-->
<!--                <van-tabbar-item icon="home-o">标签</van-tabbar-item>-->
<!--                <van-tabbar-item icon="search">标签</van-tabbar-item>-->
<!--                <van-tabbar-item icon="friends-o">标签</van-tabbar-item>-->
<!--                <van-tabbar-item icon="setting-o">标签</van-tabbar-item>-->
<!--            </van-tabbar>-->
            <van-tabbar route>
                <van-tabbar-item replace to="/home" icon="home-o">
                    首页
                </van-tabbar-item>
                <van-tabbar-item replace to="/per-information" icon="home-o">
                    个人中心
                </van-tabbar-item>
            </van-tabbar>
        </div>
    </div>
</template>

<script>
    import { Toast } from 'vant';
    export default {
        data() {
            return {
                active: 1
            }
        },
        methods: {
            onClickLeft() {
                this.$router.go(-1);//返回上一层
            },
            onClickRight() {
                Toast('按钮');
            }
        },
        watch:{

        }
    }
</script>

<style scoped>

</style>
